<template>
    <div class="content">
        <img class="banner-img" src="../../../public/img/aboutus/head_img.jpg">

        <!-- WHO WE ARE -->
        <h6 class="title_g">WHO WE ARE</h6>
        <div class="who main global_p">
            <p>Globalway, belongs to Ningbo Hooya group (since 1998), a general merchandise supplier since 2010, offering over 50,000 items, including houseware, kitchenware, personal care & beauty, gifts & seasonal items, toys, stationery, home textile, slippers, bag & luggage, travel & outdoor & BBQ items, garden tools, hand tools, car accessories, home appliance, furniture, baby and pet items.</p>
            <p>Main markets are Europe, USA, South America and Asia. Main clients are chain store, importer, wholesalerand Amazon seller. With 5 buying office in China, we buy from factories direct, every item will be produced newly under order. Can do client's special design, artwork, logo printing.</p>
        </div>

        <!-- WHAT WE DO -->
        <h6 class="title_g">WHAT WE DO</h6>
        <div class="what-we-do">
            <img src="../../../public/img/homepage/whatwedo.png" alt="">
        </div>

        <!-- PROFESSIONAL SERVICE -->
        <h6 class="title_g">PROFESSIONAL SERVICE<br><p>23 years experience of export</p></h6>
        <div class="service">
            <img src="../../../public/img/aboutus/service.jpg" alt="">
        </div>

        <!-- QUALIFICATIONS -->
        <h6 class="title_g">QUALIFICATIONS<br><p>Audit reports & certificates</p></h6>
        <van-swipe class="quali-box" indicator-color="black" :autoplay="8000">
            <van-swipe-item class="quali">
                <div><img src="../../../public/img/aboutus/1.jpg"></div>
                <div><img src="../../../public/img/aboutus/2.jpg"></div>
                <div><img src="../../../public/img/aboutus/3.jpg"></div>
            </van-swipe-item>
            <van-swipe-item class="quali">
                <div><img src="../../../public/img/aboutus/4.png"></div>
                <div><img src="../../../public/img/aboutus/5.png"></div>
                <div><img src="../../../public/img/aboutus/6.png"></div>
            </van-swipe-item>
            <van-swipe-item class="quali">
                <div><img src="../../../public/img/aboutus/7.jpg"></div>
                <div><img src="../../../public/img/aboutus/8.png"></div>
                <div><img src="../../../public/img/aboutus/9.jpg"></div>
            </van-swipe-item>
            <van-swipe-item class="quali">
                <div><img src="../../../public/img/aboutus/10.jpg"></div>
                <div><img src="../../../public/img/aboutus/11.png"></div>
                <div><img src="../../../public/img/aboutus/12.jpg"></div>
            </van-swipe-item>
        </van-swipe>

        <!-- QUALITY CONTROL -->
        <h6 class="title_g">QUALITY CONTROL<br><p>Inspection and loading</p></h6>
        <img class="building" src="../../../public/img/aboutus/quality.jpg">
        
        <!-- OUR TEAM -->
        <h6 class="title_g">OUR TEAM<br><p>Active & considerate</p></h6>
        <img class="building" style="margin-bottom: 1.5rem" src="../../../public/img/aboutus/team.jpg">
    </div>
</template>

<script>
import {
    Swipe as VanSwipe,
    SwipeItem as VanSwipeItem,
} from 'vant';

export default {
    name: 'AboutUs',
    components: { VanSwipe, VanSwipeItem }
}
</script>

<style lang="less" scoped>
    .main { margin: 0 1rem; }
    .who p { position: relative; z-index: 100; }
    .building { width: calc(100% - 1rem); margin: 0 .5rem; }
    
    .what-we-do { background-color: #d8d4d3; }
    .what-we-do img { width: 100%; padding: 1rem 0; }

    .service { overflow: auto; }
    .service img { width: calc(100% - 8px); padding: 0 4px; }

    .quali { display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: .5rem; padding: 0 .25rem 2rem; box-sizing: border-box; }
    .quali > div { height: 0; padding-bottom: 128%; border: 1px solid #4c4c4c; position: relative; }
    .quali-box .quali > div img { padding: 0 .6rem; width: calc(100% - 1.2rem); position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); }

    /deep/ .van-swipe__indicator { border: 2px solid black; width: 4px; height: 4px; }
    /deep/ .what-we-do .van-swipe__indicator { border: none; width: 6px; height: 6px; } 
</style>